<template>
  <v-card
  :width="width"
  :height="height"
  :min-height="minHeight"
  class="rounded-0 primary-background-color px-8 pb-3"
  elevation="5">
    <!-- NOTE: content -->
    <slot/>
  </v-card>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: "auto"
    },
    height: {
      type: String,
      default: "auto"
    },
    minHeight: {
      type: String,
      default: "auto"
    }
  }
}
</script>

<style>

</style>